import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import { apiFetch } from "../../../../utils/apiFetch";

const AdminLayoutRoute = ({ component: Component, title, ...rest }) => {
  const [isStaff, setIsStaff] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkStaffStatus = async () => {
      try {
        const response = await apiFetch(
          `${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/me`
        );
        if (response.ok) {
          const data = await response.json();
          setIsStaff(data.is_staff || false);
        } else {
          setIsStaff(false);
        }
      } catch (error) {
        console.error("Error checking staff status:", error);
        setIsStaff(false);
      } finally {
        setLoading(false);
      }
    };

    checkStaffStatus();
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (loading) {
          return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
              <p>Loading...</p>
            </div>
          );
        }

        if (!isStaff) {
          return <Redirect to="/dashboard" />;
        }

        return (
          <AdminLayout>
            <Component {...props} title={title} />
          </AdminLayout>
        );
      }}
    />
  );
};

export default AdminLayoutRoute;